<template>
  <el-container>
    <el-aside width="auto" class="firm-aside-menu">
      <div style="text-align: center">
        <p style="font-size: 1.3em">选择所属市场</p>
        <el-menu
          v-loading="menuLoading"
          style="height: 100%"
          :default-active="activeFirm.code"
          background-color="#f9fafe"
          text-color="#262626"
        >
          <el-menu-item
            :index="item.code"
            v-for="item in firms"
            @click="activeFirm = item"
          >
            <div slot="title">
              <el-tooltip
                effect="dark"
                :content="item.name"
                placement="right-end"
              >
                <div class="menu-title">{{ item.name }}</div>
              </el-tooltip>
            </div>
          </el-menu-item>
        </el-menu>
      </div>
    </el-aside>
    <el-main>
      <div style="padding: 10px">
        <div class="main-header">
          <span class="header-item">当前市场</span>
          <span style="font-size: 18px">
            {{ $store.state.versionControl.vuex_firm.name }}
          </span>
        </div>
        <div style="margin-top: 10px">
          <version-list v-show="true" ref="versionControl" />
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import VersionList from "./VersionList";
import misc from "@/api/misc";
import _ from "lodash";
export default {
  name: "VersionIndex",
  components: {
    VersionList
  },
  data() {
    return {
      menuLoading: false,
      showMenu: false,
      activeFirm: {},
      defaultFirm: {
        code: "all",
        name: "全部",
        simpleName: "全部"
      },
      firms: []
    };
  },
  created() {
    this.menuLoading = true;
    this.initEmptyFirm();
    this.activeFirm = this.defaultFirm;
    misc.getAllFirm().then(result => {
      result.data.forEach(val => {
        this.firms.push(val);
      });
      this.menuLoading = false;
    });
  },
  watch: {
    activeFirm: {
      handler: function(val, oldVal) {
        if (_.isEmpty(val)) {
          return;
        }
        this.$store.commit(
          this.$u.vuexConst.VERSION_CONTROL_STATE_PREFIX +
            this.$u.vuexConst.UPDATE_VERSION_FIRM,
          val
        );
        this.$nextTick(() => {
          this.$refs.versionControl.getDataList();
        });
      },
      immediate: true
    }
  },
  methods: {
    initEmptyFirm() {
      this.firms.push(this.defaultFirm);
    }
  }
};
</script>
<style scoped lang="scss">
.firm-aside-menu {
  background-color: #f9fafe;
}
.main-header {
  position: relative;
  max-width: 200px;
}
.header-item {
  margin-right: 20px;
  &::after {
    position: absolute;
    content: "";
    width: 2px;
    height: 16px;
    left: 65px;
    background-color: #dcdfe6;
    transform: translateY(25%);
  }
}
.menu-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100px;
}
</style>
